import * as React from 'react';
import './SearchResultsView.scss';
import ModelsPartsResults from './../../components/ModelsPartsResults';

interface ISearchResultsViewProps {
  onSetSearchText: (text: string) => void;
  match: any;
}

export class SearchResultsView extends React.Component<
  ISearchResultsViewProps,
  any
> {
  public componentDidMount = () => {
    const searchQuery = decodeURIComponent(this.props.match.params.text);
    if (searchQuery != null) {
      this.props.onSetSearchText(searchQuery);
    }
  };
  public render() {
    return (
      <div className="rp-search-results-view">
        <ModelsPartsResults />
      </div>
    );
  }
}
